export const SET_NEW_SCHEDULE_INSTANCES = 'CLASSTIVITY_SCHEDULER/SET_NEW_SCHEDULE_INSTANCES';
export const setNewScheduleInstances = scheduleInstances => ({
  type: SET_NEW_SCHEDULE_INSTANCES,
  scheduleInstances,
});

export const CLEAR_NEW_SCHEDULE_INSTANCES = 'CLASSTIVITY_SCHEDULER/CLEAR_NEW_SCHEDULE_INSTANCES';
export const clearNewScheduleInstances = () => ({
  type: CLEAR_NEW_SCHEDULE_INSTANCES,
});

export const SET_NEW_CLASS_ID = 'CLASSTIVITY_SCHEDULER/SET_NEW_CLASS_ID';
export const setNewClassId = newClassId => ({ type: SET_NEW_CLASS_ID, newClassId });

export const RESET_NEW_CLASS_ID = 'CLASSTIVITY_SCHEDULER/RESET_NEW_CLASS_ID';
export const resetNewClassId = () => ({ type: RESET_NEW_CLASS_ID });

export const initialState = {
  newScheduleInstances: [],
  newClassId: null,
};

export default (state = initialState, action) => {
  const { type, scheduleInstances, newClassId } = action;

  switch (type) {
    case SET_NEW_SCHEDULE_INSTANCES:
      return { ...state, newScheduleInstances: [...state.newScheduleInstances, ...scheduleInstances] };
    case CLEAR_NEW_SCHEDULE_INSTANCES:
      return { ...state, newScheduleInstances: [] };
    case SET_NEW_CLASS_ID:
      return { ...state, newClassId };
    case RESET_NEW_CLASS_ID:
      return { ...state, newClassId: initialState.newClassId };
    default:
      return state;
  }
};
